module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA1NDRjMjE0LjEgMCAzNTIgOTAuNSAzNTIgMTkydjE2MGEzMiAzMiAwIDAgMS0zMiAzMkgxOTJhMzIgMzIgMCAwIDEtMzItMzJ2LTE2MGMwLTEwMS41IDEzNy45LTE5MiAzNTItMTkyeiBtMC00NDhhMTkyIDE5MiAwIDEgMSAwIDM4NCAxOTIgMTkyIDAgMCAxIDAtMzg0eiIgZmlsbD0iIzAiIHAtaWQ9IjQ2NTciPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/User-filled.svg
// module id = 4fR/
// module chunks = 73